import { type AutocompletePlace } from 'invictus-sdk-typescript'

import { type AutocompleteResultModel } from '@DS/components/navigation/search/atoms/AutocompleteResult'
import { type AutocompleteItemModel } from '@DS/components/navigation/search/autocomplete/Autocomplete.types'

export const getFullLabel = ({ description, label }: AutocompleteResultModel | AutocompleteItemModel): string =>
  description ? `${label} (${description})` : label

export const getAutocompletePlaceFromAutocompleteResultModel = (
  resultModel: AutocompleteResultModel,
): AutocompletePlace => ({
  label: getFullLabel(resultModel),
  id: resultModel.id,
  geolocation: false,
  codes: [],
})
